module.exports = __webpack_public_path__ + "assets/img/ee45f1af451ecbe0c673ded408411f3e.png";